// extracted by mini-css-extract-plugin
export default {"iconContainer":"RoleBox_iconContainer__mE+w9","container":"RoleBox_container__A9A9D","roleBox":"RoleBox_roleBox__iVx-r"};